"use strict";

exports.__esModule = true;
var _Axis = require("./Axis");
Object.keys(_Axis).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Axis[key]) return;
  exports[key] = _Axis[key];
});
var _DurationAxis = require("./DurationAxis");
Object.keys(_DurationAxis).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DurationAxis[key]) return;
  exports[key] = _DurationAxis[key];
});